/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageSubTypeGroupModel {
        public subTypeGroups: Wars.Domain.Model.SystemSubTypeGroup[];
        public currentSubTypeGroup: Wars.Domain.Model.SystemSubTypeGroup;
        
        constructor(
            private subTypeGroupService: services.SubTypeGroupService,
            private deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService)
        {
            systemLevelService.getSystemLevelSubTypeGroups().then(
                (systemLevel) => {
                    this.subTypeGroups = systemLevel.mySubTypeGroups;
                });
        }

        public addSubTypeGroup(): void {
            var newSubTypeGroup = this.subTypeGroupService.createNewSubTypeGroup();
            this.subTypeGroups.push(newSubTypeGroup);
            newSubTypeGroup.isActive = true;
            this.currentSubTypeGroup = newSubTypeGroup;
        }

        public editSubTypeGroup(subTypeGroup: Wars.Domain.Model.SystemSubTypeGroup) {
            this.currentSubTypeGroup = subTypeGroup;
        }

        public removeSubTypeGroup(subTypeGroup: Wars.Domain.Model.SystemSubTypeGroup) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "SystemSubTypeGroup",
                subTypeGroup.id,
                "Sub Type Group",
                () => this.subTypeGroups.remove(subTypeGroup));
        }

        public save(): void {
            this.subTypeGroupService.saveAllChanges();
        }

        public close(): void {
            this.currentSubTypeGroup = undefined;
        }
    }
}